<template>
    <div>
        <div class="row mb-2">
            <div class="col-auto">
                <strong>Email address:</strong>
            </div>
            <div class="col">
                <a :href="'mailto:' + claimFileEmailAddress">{{claimFileEmailAddress}}</a> &nbsp; <i class="far fa-copy" v-b-tooltip.hover :title="copyToPopupText" v-on:click="copyToClipboard(claimFileEmailAddress)"></i>
            </div>
        </div>

        <button class="btn btn-lg btn-primary mb-3" @click="handleComposeClick()">New message</button>
        <button class="btn btn btn-primary mb-3 ml-2" v-if="claimHasStatus(1009) || claimHasStatus(1011)" @click="handleComposeTemplatesClick(TEMPLATE_TYPES.NEW_APPROVE_TEMPLATE)">Approve message</button>
        <button class="btn btn btn-primary mb-3 ml-2" v-if="claimHasStatus(1024)" @click="handleComposeTemplatesClick(TEMPLATE_TYPES.NEW_DECLINE_TEMPLATE)">Decline message</button>
        <button class="btn btn btn-primary mb-3 ml-2" @click="handleComposeTemplatesClick(TEMPLATE_TYPES.NEW_DOCS_TEMPLATE)">Document request message</button>
        <button class="btn btn btn-primary mb-3 ml-2" @click="handleComposeTemplatesClick(TEMPLATE_TYPES.NEW_CLAIM_PAYMENT_TEMPLATE)">Claim payment message</button>

        <b-card no-body>
            <b-tabs card>
                <b-tab title="Received">
                    <button type="button" class="btn btn-secondary btn-sm float-right ml-2 mb-2" v-on:click="handlePaginationInput(1)"><i class="fas fa-sync-alt"></i> Refresh</button>
                    <message-list :eventTarget="eventTarget"
                                  :key="'claim_message_message_list'"
                                  :buttonConfig="buttonConfig"
                                  :dataListCols="messageDataListCols"
                                  :messages="messages"
                                  :pagination="pagination"
                                  @message-pagination-click="handlePaginationInput"
                                  :windowWidth="windowWidth"
                                  :availableTags="availableTags" />
                </b-tab>
                <b-tab title="Sent (Email History)">
                    <button type="button" class="btn btn-secondary btn-sm float-right ml-2 mb-2" v-on:click="handleEmailHistoryPagenationInput(1)"><i class="fas fa-sync-alt"></i> Refresh</button>
                    <data-list-pagination :dataCols="claimEmailHistoryCols"
                                          :dataListItems="emailHistoryDetails"
                                          :tableClass="'table table-striped table-sm'"
                                          @dbl-click="sentMessageDoubleClick"
                                          @pagination-input="handleEmailHistoryPagenationInput" />
                </b-tab>
            </b-tabs>
        </b-card>


        <slideout-panel></slideout-panel>
        
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import EventBus from "@/messageEventBus.js";
    import {
        MESSAGES_PAGINATION,
        GET_EMAIL_DOCUMENT,
        GET_EMAIL_DOCUMENT_COMPLETE,
        LINK_MESSAGE_TO_CLAIM,
        LINK_MESSAGE_TO_CLAIM_COMPLETE,
        SEND_EMAIL,
        SEND_EMAIL_COMPLETE,
        GET_TAGS_FOR_CLAIM_MESSAGE,
        GET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE,
        SET_TAGS_FOR_CLAIM_MESSAGE,
        SET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE,
        DOWNLOAD_MESSAGE_ATTACHMENT,
        PREVIEW_EMAIL,
        PREVIEW_EMAIL_COMPLETE,
        MESSAGE_VIEWER_CLOSED,
        MESSAGES_COLUMN_CLICK,
        SET_MESSAGE_TASK
    } from "@/messageEvents.js";

    import {
        NEW_MESSAGE,
        NEW_APPROVE_TEMPLATE,
        NEW_DECLINE_TEMPLATE,
        NEW_DOCS_TEMPLATE,
        NEW_CLAIM_PAYMENT_TEMPLATE
    } from './Messages/composeActionTypes.js';

    import { claimEmailHistoryCols } from '@/ui.config/cols/claimEmailHistoryCols'
    import { reportsApiService } from '@/services/reports-api.service.js'

    export default {
        name: 'ClaimMessages',
        props: {
            claimId: { type: Number, required: true },
            claimReference: { type: String, required: false, default: null }
        },
        components: {

        },

        data: () => {
            return {
                isLoading: false,

                claimEmailHistoryCols: claimEmailHistoryCols,

                messagesPageNumber: 1,
                messagesPageSize: 10,
                messagesTotalRecords: 0,
                messagesOrderBy: 'DocumentDateCreatedUTC',
                messagesSortDirection: 'DESC',

                emailHistory: {
                    pageNumber: 1,
                    pageSize: 10
                },
                TEMPLATE_TYPES: {
                    NEW_APPROVE_TEMPLATE,
                    NEW_DECLINE_TEMPLATE,
                    NEW_DOCS_TEMPLATE,
                    NEW_CLAIM_PAYMENT_TEMPLATE
                },
                availableTags: [
                    { text: "CLAIM_MESSAGE_TAG_1" },
                    { text: "CLAIM_MESSAGE_TAG_2" },
                    { text: "CLAIM_MESSAGE_TAG_3" },
                    { text: "CLAIM_MESSAGE_TAG_4" }
                ],

                windowWidth: 0,

                copyToPopupText: 'Copy to clipboard'
            }
        },
        computed: {
            ...mapGetters({
                messageDataListCols: "messageStore/dataListCols",
                messages: "messageStore/messages",
                emailAddresses: "messageStore/emailAddresses",
                emailDocument: "messageStore/selectedEmailDocument",
                pagination: "messageStore/pagination"
            }),
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            eventTarget() {
                return 'claim_message_message_list'
            },
            buttonConfig() {
                return {
                    reply: {
                        enabled: true
                    },
                    assign: {
                        enabled: false
                    },
                    tag: {
                        enabled: true
                    }
                }
            },
            sentButtonConfig() {
                return {
                    reply: {
                        enabled: false
                    },
                    assign: {
                        enabled: false
                    },
                    tag: {
                        enabled: false
                    }
                }
            },
            emailHistoryDetails() {
                return this.$store.getters.selectedClaim.emailHistoryDetails
            },
            attachmentUrl() {
                return '/api/admin/v1/message/download/'
            },
            claimFileEmailAddress() {
                if (this.selectedClaim) {
                    return this.selectedClaim.claimFileEmailAddress
                }
                return null
            }
        },
        mounted() {

        },
        watch: {

        },
        methods: {
            ...mapActions({
                loadMessages: "messageStore/fetchMessagesForClaim",
                getEmailDocument: "messageStore/fetchEmailDocument",
                getEmailAddresses: "messageStore/fetchAddressesForClaim",
                sendEmail: "messageStore/sendEmail",
                previewEmail: 'messageStore/previewEmail',
                resetMessages: "messageStore/resetMessages",
                fetchEmailHistory: 'fetchEmailHistoryClaim',
                fetchTagsForClaimMessage: 'messageStore/fetchTagsForClaimMessage',
                setTagsFlorClaimMessage: 'messageStore/setTagsFlorClaimMessage',
                setMessageCompleteTask: 'messageStore/setMessageCompleteTask',
                fetchAttachmentsForClaim: 'messageStore/fetchAttachmentsForClaim'
            }),
            claimHasStatus(statusId) {
                let { claimStatusDetails } = this.selectedClaim
                if (claimStatusDetails) {
                    return claimStatusDetails.filter(o => o.statusId == statusId).length > 0
                }
                return false
            },
            buildParams() {
                let params = {};

                if (this.claimId) {
                    params.claimId = this.claimId;
                } else {
                    params.withoutClaim = true;
                }

                let {
                    messagesOrderBy: orderBy,
                    messagesSortDirection: sortDir,
                    messagesPageSize: pageSize,
                    messagesPageNumber: pageNumber
                } = this

                return {
                    ...params,
                    orderBy,
                    sortDir,
                    pageSize,
                    pageNumber
                }


            },
            handlePaginationInput(payload) {

                this.messagesPageNumber = payload
                let loading = this.$loading.show({
                    containier: null,
                    canCancel: false
                })
                this.loadMessages(this.buildParams())
                    .then()
                    .catch(error => console.log("error2: ", error))
                    .finally(() => {
                        loading.hide();
                    });
            },
            sentMessageDoubleClick(message) {

                let { messageTo: to, messageFrom: from, messageSubject: subject, messageBody: html } = message

                const panel1Handle = this.$showPanel({
                    component: "message-viewer",
                    openOn: "right",
                    cssClass: "",
                    width: this.windowWidth * 0.99,
                    props: {
                        eventTarget: this.eventTarget,
                        buttonConfig: this.sentButtonConfig,
                        messageHeader: { to, from, subject },
                        messageDocument: { html },
                        windowWidth: this.windowWidth
                    }
                });
            },
            handleResize() {
                this.windowWidth = window.innerWidth;
            },
            handleComposeClick() {
                const panel1Handle = this.$showPanel({
                    component: "message-compose",
                    openOn: "right",
                    cssClass: "",
                    width: this.windowWidth * 0.99,
                    props: {
                        eventTarget: this.eventTarget,
                        emailAddresses: this.emailAddresses,
                        messageSubject: `Your claim: ${this.claimReference}`,
                        actionType: NEW_MESSAGE
                    }
                });
                panel1Handle.promise.then(result => { });
            },
            handleComposeTemplatesClick(template) {
                const panel1Handle = this.$showPanel({
                    component: "message-compose-templates",
                    openOn: "right",
                    cssClass: "",
                    width: this.windowWidth * 0.99,
                    props: {
                        eventTarget: this.eventTarget,
                        templateType: template
                    }
                });
            },
            handleEmailHistoryPagenationInput(payload) {
                this.emailHistory.pageNumber = payload
                this.searchEmailHistory()
                this.fetchAttachmentsForClaim(this.claimId)

            },
            searchEmailHistory() {
                let { claimId } = this
                let { pageSize, pageNumber } = this.emailHistory

                let ordering = null

                let pages = {
                    pageSize,
                    pageNumber
                }

                let criteria = {
                    claimId,
                    ...pages,
                    ...ordering
                }

                let loading = this.$loading.show({
                    containier: null,
                    canCancel: false
                })
                this.fetchEmailHistory(criteria)
                .finally( () => loading.hide() )
            },
            copyToClipboard(val) {

                var tempInput = document.createElement("input");
                tempInput.value = val;
                document.body.appendChild(tempInput);
                tempInput.select();
                try {
                    if (document.execCommand('copy')) {
                        this.copyToPopupText = 'Copied'
                        let self = this
                        setTimeout(function () {
                            self.copyToPopupText = 'Copy to clipboard'
                        }, 2000);
                    }
                    
                } catch (err) {
                    console.log(err)
                }

                document.body.removeChild(tempInput);

                
            }
        },
        created() {
            window.addEventListener("resize", this.handleResize);
            this.handleResize();

            //window.onbeforeunload = confirmExit;
            //function confirmExit() {
            //    return "Changes that you have made may not be saved.";
            //}
        },
        beforeDestroy() {
            this.resetMessages()
            EventBus.$off(GET_EMAIL_DOCUMENT + '_' + this.eventTarget)
            EventBus.$off(MESSAGES_PAGINATION + '_' + this.eventTarget)
            EventBus.$off(SEND_EMAIL + '_' + this.eventTarget)
            EventBus.$off(PREVIEW_EMAIL + '_' + this.eventTarget)
            EventBus.$off(GET_TAGS_FOR_CLAIM_MESSAGE + '_' + this.eventTarget)
            EventBus.$off(MESSAGE_VIEWER_CLOSED)
            EventBus.$off(MESSAGES_COLUMN_CLICK + '_' + this.eventTarget)
            EventBus.$off(SET_MESSAGE_TASK + '_' + this.eventTarget)
        },
        destroyed() {

            window.removeEventListener("resize", this.handleResize);
            //window.onbeforeunload = null;


        },
        mounted() {

            EventBus.$on(MESSAGE_VIEWER_CLOSED, () => {
                //if (this.claimId) {
                //    params.claimId = this.claimId;
                //} else {
                //    params.withoutClaim = true;
                //}
                //params.pageNumber = this.messagesPageNumber;
                //console.log(params)
                //console.log(this.buildParams())

                this.loadMessages(this.buildParams())
                    .then()
                    .catch(error => console.log("error2: ", error))
                    .finally(() => {
                        //console.log("all done!");
                    });
            })

            EventBus.$on(SET_MESSAGE_TASK + '_' + this.eventTarget, payload => {
                //console.log(SET_MESSAGE_TASK + '_' + this.eventTarget + ': ', payload)
                let loading = this.$loading.show({
                    containier: null,
                    canCancel: false
                })

                this.setMessageCompleteTask(payload)
                    .then(response => {
                        //console.log(response)
                        this.loadMessages(this.buildParams())
                            .then()
                            .catch(error => console.log(error))
                            .finally(() => {
                                loading.hide()
                            });
                    })
                    .catch(error => console.log(error))
                    .finally(() => {
                        loading.hide()
                    })
            })

            EventBus.$on(GET_TAGS_FOR_CLAIM_MESSAGE + '_' + this.eventTarget, payload => {
                //console.log(GET_TAGS_FOR_CLAIM_MESSAGE + '_' + this.eventTarget + ": ", payload);
                this.fetchTagsForClaimMessage({ claimId: this.claimId, messageId: payload.id })
                    .then(
                        response => {
                            EventBus.$emit(GET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE + '_' + payload.id, response.data);
                        },
                        error => reject(error)
                    )
                    .catch(error => console.log(error));
            });

            EventBus.$on(GET_EMAIL_DOCUMENT + '_' + this.eventTarget, payload => {
                //console.log(GET_EMAIL_DOCUMENT + ": ", payload);
                this.getEmailDocument(payload.documentId)
                    .then(
                        response => {
                            EventBus.$emit(GET_EMAIL_DOCUMENT_COMPLETE + '_' + payload.id, response.data);
                        },
                        error => reject(error)
                    )
                    .catch(error => console.log(error));
            });

            EventBus.$on(MESSAGES_PAGINATION + '_' + this.eventTarget, this.handlePaginationInput);

            EventBus.$on(MESSAGES_COLUMN_CLICK + '_' + this.eventTarget, payload => {
                //console.log(MESSAGES_COLUMN_CLICK + ' - ', payload)

                switch (payload.key) {
                    case 'documentDateCreatedDisplay':
                        this.messagesOrderBy = 'DocumentDateCreatedUTC'
                        if (this.messagesSortDirection == null || this.messagesSortDirection == 'ASC') {
                            this.messagesSortDirection = 'DESC'
                        } else {
                            this.messagesSortDirection = 'ASC'
                        }
                        break;
                    case 'from':
                        this.messagesOrderBy = 'From'
                        if (this.messagesSortDirection == null || this.messagesSortDirection == 'ASC') {
                            this.messagesSortDirection = 'DESC'
                        } else {
                            this.messagesSortDirection = 'ASC'
                        }
                        break;
                    case 'subject':
                        this.messagesOrderBy = 'Subject'
                        if (this.messagesSortDirection == null || this.messagesSortDirection == 'ASC') {
                            this.messagesSortDirection = 'DESC'
                        } else {
                            this.messagesSortDirection = 'ASC'
                        }
                        break;
                    case 'taskDateCompletedDisplay':
                        this.messagesOrderBy = 'DateCompleted'
                        if (this.messagesSortDirection == null || this.messagesSortDirection == 'ASC') {
                            this.messagesSortDirection = 'DESC'
                        } else {
                            this.messagesSortDirection = 'ASC'
                        }
                        break;
                }

                //console.log(this.buildParams())

                let loading = this.$loading.show({
                    containier: null,
                    canCancel: false
                })
                this.loadMessages(this.buildParams())
                    .then()
                    .catch(error => console.log(error))
                    .finally(() => {
                        loading.hide()
                    });

            });

            let params = {};

            EventBus.$on(SEND_EMAIL + '_' + this.eventTarget, payload => {
                //console.log(SEND_EMAIL + '_' + this.eventTarget + ": ", payload);
                this.sendEmail({ claimId: this.claimId, ...payload })
                    .then(
                        response => {
                            //console.log(SEND_EMAIL, response)
                            this.searchEmailHistory()
                            EventBus.$emit(SEND_EMAIL_COMPLETE + '_' + payload.eventId, response.data);
                        },
                        error => reject(error)
                    )
                    .catch(error => console.log(error));
            });

            EventBus.$on(PREVIEW_EMAIL + '_' + this.eventTarget, payload => {
                //console.log(PREVIEW_EMAIL + '_' + this.eventTarget, payload)
                EventBus.$emit(PREVIEW_EMAIL_COMPLETE + '_' + payload.eventId, '*_*');
                this.previewEmail({ claimId: this.claimId, ...payload })
                    .then(
                        response => {                            
                            EventBus.$emit(PREVIEW_EMAIL_COMPLETE + '_' + payload.eventId, response.data);
                        },
                        error => reject(error)
                    )
                    .catch(error => console.log(error));
            });

            EventBus.$on(DOWNLOAD_MESSAGE_ATTACHMENT + '_' + this.eventTarget, payload => {
                reportsApiService.getDownloadKey()
                    .then( response => {
                        window.open(
                            this.attachmentUrl + payload + '/' + response.data,
                            '_blank'
                        )
                    })
            })

            EventBus.$on(SET_TAGS_FOR_CLAIM_MESSAGE + '_' + this.eventTarget, payload => {
                //console.log(SET_TAGS_FOR_CLAIM_MESSAGE + '_' + this.eventTarget + ": ", payload);
                let { claimId } = this
                let { messageId, selectedTags } = payload
                this.setTagsFlorClaimMessage({ claimId, messageId, tags: selectedTags.map(t => t.id)})
                    .then(
                        response => {
                            EventBus.$emit(SET_TAGS_FOR_CLAIM_MESSAGE_COMPLETE + '_' + payload.eventId, response.data);
                            // RELOAD MESSAGES
                            if (this.claimId) {
                                params.claimId = this.claimId;
                            } else {
                                params.withoutClaim = true;
                            }
                            params.pageNumber = this.messagesPageNumber;
                            this.loadMessages(params)
                                .then()
                                .catch(error => console.log(error))
                                .finally(() => {
                                    //console.log("all done!");
                                });
                        },
                        error => reject(error)
                    )
                    .catch(error => console.log(error));
            });

            this.loadMessages(this.buildParams())
                .then()
                .catch(error => console.log("error2: ", error))
                .finally(() => {
                    console.log("all done!");
                });

            this.getEmailAddresses(this.claimId)
                .then()
                .catch()
                .finally();
        },
    }
</script>
<style>
</style>

